<h3 mat-dialog-title>{{'contentTypes.schemaItem' | translate}}</h3>
<mat-dialog-content>
  <div class="py-2">
    <section class="my-2 rounded m-auto w-100" id="section">
      <form [formGroup]="schemaPropertyForm" class="m-1">
        <div class="input-group my-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label data-nar="content-type-schema-type">{{'content.type' | translate}} </mat-label>
            <mat-select formControlName="type" class="input-group" required>
              @for (option of typesOptions; track option; let index = $index) {
                <mat-option value="{{option.type}}">
                  <mat-icon class="material-symbols-outlined" style="color:#646669;">{{option.mat_icon}}</mat-icon>
                  <div class="d-flex align-items-center">
                    <!-- <span class="material-symbols-outlined" style="color: var(--warmOrange);">
                    {{option.icon}}
                  </span> -->
                  <span class="ps-2"> {{schemaTypeLabel(option.type)}}</span>
                </div>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (schemaPropertyForm.value.type=='array') {
        <div class="input-group my-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'content.listItemsType' | translate}} </mat-label>
            <mat-select formControlName="listItemsType" class="input-group">
              @for (option of listTypesOptions; track option; let index = $index) {
                <mat-option value="{{option.type}}">
                  <mat-icon class="material-symbols-outlined" style="color:#646669;">{{option.mat_icon}}</mat-icon>
                  <div class="d-flex align-items-center">
                    <span class="ps-2"> {{schemaTypeLabel(option.type)}}</span>
                  </div>
                </mat-option>
              }
            </mat-select>
            @if (schemaPropertyForm.get('type').errors && schemaPropertyForm.get('type').errors['required']) {
              <mat-error>{{'taskTemplates.mandatory' | translate}}</mat-error>
            }
          </mat-form-field>
        </div>
      }

      @if (schemaPropertyForm.value.type=='date' ||  schemaPropertyForm.value.listItemsType=='date') {
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'contentTypes.dateFormat' | translate}}</mat-label>
          <input matInput formControlName="dateFormat"  placeholder="Format" type="text">
        </mat-form-field>
      }


      <mat-form-field appearance="outline" class="w-100 my-1">
        <mat-label>{{'content.key' | translate}}</mat-label>
        <input formControlName="key" type="text" name="key" matInput placeholder="{{'taskTemplates.key' | translate}}" id="key" required>
        @if (schemaPropertyForm.get('key').errors && schemaPropertyForm.get('key').errors['required']) {
          <mat-error>{{'taskTemplates.mandatory' | translate}}</mat-error>
        }
        @if (schemaPropertyForm.get('key')?.errors && schemaPropertyForm.get('key')?.errors['pattern']) {
          <mat-error>{{'taskTemplates.valid-key' | translate}}</mat-error>
        }
        <mat-hint>{{'taskTemplates.valid-key' | translate}}</mat-hint>
      </mat-form-field>

      <mat-form-field  appearance="outline" class="w-100">
        <mat-label>{{'contentTypes.description' | translate}}</mat-label>
        <input matInput formControlName="description"  placeholder="{{'contentTypes.description' | translate}}" type="text" data-nar="content-type-schema-description">
      </mat-form-field>

      <div class="p-3 mb-2 form-control d-flex justify-content-between">
        <label for="value">{{'contentTypes.mandatory' | translate}}</label>
        <mat-slide-toggle class="example-margin" formControlName="mandatory" data-nar="content-type-schema-mandatory"></mat-slide-toggle>
      </div>

      @if (metaTemplate?.fields?.length) {
        <mat-expansion-panel class="metadata-panel" [expanded]="metadataExpanded" (opened)="metadataExpanded = true" (closed)="metadataExpanded = false">
          <mat-expansion-panel-header>
            <mat-panel-title>{{'contentTypes.fieldMetadata' | translate}}</mat-panel-title>
          </mat-expansion-panel-header>
          <app-schema-meta-form
            [metaTemplate]="metaTemplate"
            [fieldMeta]="fieldMeta"
            [showTemplateEditor]="false"
            [showValuesHeading]="false"
            [showValidationErrors]="showMetaValidationErrors"
            (fieldMetaChange)="updateFieldMeta($event)">
          </app-schema-meta-form>
        </mat-expansion-panel>
      }

      <mat-expansion-panel class="access-panel" [expanded]="accessExpanded" (opened)="accessExpanded = true" (closed)="accessExpanded = false">
        <mat-expansion-panel-header>
          <mat-panel-title>{{'contentTypes.fieldAccess' | translate}}</mat-panel-title>
          <mat-panel-description>{{(accessEnabled ? 'contentTypes.fieldAccessRestricted' : inheritedAccessFrom ? 'contentTypes.fieldAccessInherited' : 'contentTypes.fieldAccessOpen') | translate}}</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="access-panel-body">
          @if (inheritedAccessFrom && !accessEnabled) {
            <p [textContent]="'contentTypes.fieldAccessInheritedHint' | translate: { field: inheritedAccessFrom }"></p>
            <p>{{'contentTypes.fieldAccessInheritedReadOnly' | translate}}</p>
          } @else {
            <p>{{'contentTypes.fieldAccessHint' | translate}}</p>
          }
          <mat-slide-toggle [checked]="accessEnabled" [disabled]="!!inheritedAccessFrom && !accessEnabled" (change)="setAccessEnabled($event.checked)">
            {{'contentTypes.fieldAccessCustom' | translate}}
          </mat-slide-toggle>

          @if (accessEnabled) {
            <p class="access-inheritance-hint">{{'contentTypes.fieldAccessInheritanceHint' | translate}}</p>
            <div class="access-role-list">
              @for (role of accessRoles; track role) {
                <div class="access-role-row">
                  <div class="access-role-heading">
                    <strong>{{role === 'public' ? ('contentTypes.fieldAccessPublic' | translate) : role}}</strong>
                    @if (role === 'public') {
                      <small>{{'contentTypes.fieldAccessPublicHint' | translate}}</small>
                    } @else {
                      <button mat-icon-button type="button" [attr.aria-label]="('contentTypes.fieldAccessRemoveRole' | translate) + ': ' + role" (click)="removeAccessRole(role)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  </div>
                  <div class="access-permissions">
                    @for (permission of role === 'public' ? ['R'] : accessPermissions; track permission) {
                      <mat-checkbox [checked]="hasAccessPermission(role, permission)" (change)="setAccessPermission(role, permission, $event.checked)">
                        {{('contentTypes.fieldAccessPermission.' + permission) | translate}}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="access-add-role">
              <mat-form-field appearance="outline">
                <mat-label>{{'contentTypes.fieldAccessRole' | translate}}</mat-label>
                <input matInput [(ngModel)]="newAccessRole" [ngModelOptions]="{ standalone: true }" (keydown.enter)="$event.preventDefault(); addAccessRole()">
                @if (accessRoleErrorKey) {
                  <mat-hint class="access-role-error">{{accessRoleErrorKey | translate}}</mat-hint>
                }
              </mat-form-field>
              <button mat-button type="button" class="secondary-gray-button" [disabled]="!newAccessRole.trim() || !!accessRoleErrorKey" (click)="addAccessRole()">
                <mat-icon>add</mat-icon> {{'contentTypes.fieldAccessAddRole' | translate}}
              </button>
            </div>
          }
        </div>
      </mat-expansion-panel>

      @if(schemaPropertyForm.value?.type != 'boolean' && schemaPropertyForm.value?.type != 'object') {
          <mat-expansion-panel class="validators-panel" [expanded]="rulesExpanded" (opened)="rulesExpanded = true" (closed)="rulesExpanded = false">
            <mat-expansion-panel-header>
              <mat-panel-title>{{'contentTypes.schemaRulesTitle' | translate}}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="validators-header">
              <p>{{'contentTypes.schemaRulesDescription' | translate}}</p>

              <button mat-button [matMenuTriggerFor]="menu" class="my-3 secondary-gray-button validator-add-button" id="btn-add" data-nar="content-type-schema-add-validator">
                <mat-icon>add_circle</mat-icon> {{'contentTypes.addSchemaRule' | translate}}
              </button>
              <mat-menu #menu="matMenu">
                @for( val of getAvailableValidators(); track val;) {
                  <button mat-menu-item (click)="addValidator(val)" [disabled]="checkDisabledType(val)">
                    <mat-icon>{{getValidatorIcon(val.type)}}</mat-icon>
                    <span>{{getValidatorLabel(val.type)}}</span>
                  </button>
                }
              </mat-menu>
            </div>

            @if (!allValidators?.length) {
              <div class="validators-empty">
                <mat-icon>rule</mat-icon>
                <div>
                  <strong>{{'contentTypes.noSchemaRules' | translate}}</strong>
                  <p>{{'contentTypes.noSchemaRulesDescription' | translate}}</p>
                </div>
              </div>
            }

            @if (allValidators?.length) {
              <div class="validators-list">
                @for( v of allValidators; track v; let index = $index) {
                  <article class="validator-card">
                    <div class="validator-card-main">
                      <span class="validator-icon"><mat-icon>{{getValidatorIcon(v.type)}}</mat-icon></span>
                      <div>
                        <strong>{{getValidatorLabel(v.type)}}</strong>
                        <p>{{getValidatorSummary(v)}}</p>
                      </div>
                    </div>

                    <div class="validator-actions">
                      <button mat-icon-button [attr.aria-label]="'contentTypes.editSchemaRule' | translate" (click)="openValidatorDialog(v, index, 'edit');">
                        <mat-icon class="material-symbols-outlined">edit</mat-icon>
                      </button>
                      <button mat-icon-button [attr.aria-label]="'contentTypes.deleteSchemaRule' | translate" (click)="deleteValidator(v, index);">
                        <mat-icon class="material-symbols-outlined delete">delete</mat-icon>
                      </button>
                    </div>
                  </article>
                }
              </div>
            }
          </mat-expansion-panel>
      }
    </form>
  </section>
</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancelEdit();">{{'cancel' | translate}}</button>
  <button mat-button
    class="orange-button"
    [disabled]="!schemaPropertyForm.valid"
  (click)="onSaveEdit();" data-nar="content-type-schema-save">{{'save' | translate}}</button>
</mat-dialog-actions>
